export const siteLinks = Object.freeze({
  home: "/",
  core: "/core-platform",
  enterprise: "/enterprise-loesning",
  nis2: "/nis2",
  nis2Report: "/nis2-rapport",
  dora: "/dora",
  contact: "/kontakt",
  demo: "/kontakt#book-demo"
});

export const companyProfile = Object.freeze({
  name: "Obsero",
  legalName: "Obsero A/S",
  slogan: "Strategisk ro. Dokumenteret ansvar. Compliance i drift.",
  address: "Nålemagervej 1",
  postalCity: "9000 Aalborg",
  cvr: "45924211",
  email: "info@obsero.dk",
  emailHref: "mailto:info@obsero.dk?subject=Book%20demo%20med%20Obsero",
  phone: "+45 25 24 77 98",
  phoneHref: "tel:+4525247798"
});

export const mainNavigation = [
  {
    key: "enterprise",
    label: "Enterprise",
    href: siteLinks.enterprise,
    activeKeys: ["enterprise"]
  },
  {
    key: "core",
    label: "Core",
    href: siteLinks.core,
    activeKeys: ["core"]
  },
  {
    key: "nis2",
    label: "NIS2",
    href: siteLinks.nis2,
    activeKeys: ["nis2", "nis2_report"]
  },
  {
    key: "dora",
    label: "DORA",
    href: siteLinks.dora,
    activeKeys: ["dora"]
  },
  {
    key: "contact",
    label: "Kontakt",
    href: siteLinks.contact,
    activeKeys: ["contact"]
  }
];

export const solutionSummaries = [
  {
    key: "core",
    label: "Obsero Core",
    eyebrow: "Til større SMV'er",
    href: siteLinks.core,
    copy: "Det professionelle governance-fundament uden tung systemimplementering. Vi bygger oven på de systemer, I allerede har i drift — så I sparer tid, undgår dobbeltarbejde og bevarer det overblik, I kender.",
    fit: [
      "Alle politikker, kontroller og processer er gennemarbejdet og klar til brug.",
      "I tilpasser, godkender og implementerer i jeres egne systemer."
    ]
  },
  {
    key: "enterprise",
    label: "Obsero Enterprise",
    eyebrow: "Til større organisationer",
    href: siteLinks.enterprise,
    copy: "Danmarks eneste fuldt ServiceNow-understøttede NIS2- og DORA-løsning. Vi implementerer og automatiserer jeres compliance — så ledelsen altid har realtidsoverblik og dokumenteret ansvar.",
    fit: [
      "Klar til ServiceNow.",
      "Alle moduler implementeres i ServiceNow.",
      "Med Obsero som compliancepartner når du helt i mål på få måneder."
    ]
  }
];

export const operatingPrinciples = [
  {
    title: "Et gennemtestet fundament",
    copy: "Vi leverer et fundament, som vi ved virker. Politikker, kontroller og processer i samspil – klar til at blive tilpasset og implementeret direkte i jeres organisation."
  },
  {
    title: "Dyb specialistviden",
    copy: "Vi har bygget Obsero på en dyb og mangeårig erfaring fra IT-sikkerhed og regulatorisk compliance. Vores viden bliver grundlaget for det framework, som jeres løsning bygger på. Konkrete erfaringer – skabt af virkeligheden."
  },
  {
    title: "Vi tager ansvar for resultatet",
    copy: "Følger I vores leveranceplan, garanterer vi et stærkt og operationelt fundament. Vi står til rådighed i hele jeres abonnementsperiode og sikrer, at jeres compliance-setup er implementeret, forankret og fungerer i drift."
  },
];
